module.exports = __webpack_public_path__ + "img/logo.9448ff40.png";